// ADR-069-B — Rule MKT-FE-01/02.
//
// ⚠️ Orval hook names used inside the page components (useV1Marketplace...)
// are BEST-GUESS per Rule MKT-FE-05 / the project's established
// "grep the actual v1.ts, never assume" rule. Antigravity must run orval
// after the backend from AM-010 is merged, grep the real hook names, and
// fix imports accordingly before wiring these pages up for real.

import { RouteObject } from "react-router-dom";
import { MarketplaceHomePage } from "./pages/MarketplaceHomePage";
import { ListingListPage } from "./pages/ListingListPage";
import { ListingCreatePage } from "./pages/ListingCreatePage";
import { ListingDetailPage } from "./pages/ListingDetailPage";
import { OrderListPage } from "./pages/OrderListPage";
import { OrderDetailPage } from "./pages/OrderDetailPage";
import { StoreListPage } from "./pages/StoreListPage";
import { StoreCreatePage } from "./pages/StoreCreatePage";
import { CatalogListPage } from "./pages/CatalogListPage";
import { CatalogCreatePage } from "./pages/CatalogCreatePage";
import MarketplaceHomeHelp from "./help/marketplace-home.mdx";
import ListingListHelp from "./help/listing-list.mdx";
import ListingCreateHelp from "./help/listing-create.mdx";
import ListingDetailHelp from "./help/listing-detail.mdx";
import OrderListHelp from "./help/order-list.mdx";
import OrderDetailHelp from "./help/order-detail.mdx";
import StoreListHelp from "./help/store-list.mdx";
import StoreCreateHelp from "./help/store-create.mdx";
import CatalogListHelp from "./help/catalog-list.mdx";
import CatalogCreateHelp from "./help/catalog-create.mdx";

export const MarketplaceRoutes: RouteObject[] = [
  { path: "help/marketplace", element: <MarketplaceHomeHelp /> },
  { path: "help/marketplace/listings", element: <ListingListHelp /> },
  { path: "help/marketplace/listing-create", element: <ListingCreateHelp /> },
  { path: "help/marketplace/listing-detail", element: <ListingDetailHelp /> },
  { path: "help/marketplace/orders", element: <OrderListHelp /> },
  { path: "help/marketplace/order-detail", element: <OrderDetailHelp /> },
  { path: "help/marketplace/stores", element: <StoreListHelp /> },
  { path: "help/marketplace/store-create", element: <StoreCreateHelp /> },
  { path: "help/marketplace/catalogs", element: <CatalogListHelp /> },
  { path: "help/marketplace/catalog-create", element: <CatalogCreateHelp /> },
  {
    path: "marketplace",
    element: <MarketplaceHomePage />,
  },
  {
    path: "marketplace/listings",
    element: <ListingListPage />,
  },
  {
    path: "marketplace/listings/new",
    element: <ListingCreatePage />,
  },
  {
    path: "marketplace/listings/:id",
    element: <ListingDetailPage />,
  },
  {
    path: "marketplace/orders",
    element: <OrderListPage />,
  },
  {
    path: "marketplace/orders/:id",
    element: <OrderDetailPage />,
  },
  {
    path: "marketplace/stores",
    element: <StoreListPage />,
  },
  {
    path: "marketplace/stores/new",
    element: <StoreCreatePage />,
  },
  {
    path: "marketplace/catalog",
    element: <CatalogListPage />,
  },
  {
    path: "marketplace/catalog/new",
    element: <CatalogCreatePage />,
  }
];
